import axios from "axios";

import moment from "moment";

const Comitente = {
  namespaced: true,
  state: {
    load: false,
    numero: 0,
    cbus: [],
    cbus_paginado: null,

    ojo: false,

    cuits: [],

    disponible: {
      load: false,
      error: null,
      date: moment(new Date(Date.now())).format("YYYYMMDD"),
      data: {
        pesos: null,
        dolar: null,
        mep: null,
      },
    },

    load_disponible: false,

    transferencias: [],
    transferencias_paginado: null,
    load_transferencias: false,

    cbus_habilitados: [],

    comitentes: {
      load: false,
      data: [],
      buscados: [],
    },

    comitenteSel: {
      numero: 0,
      denominacion: "Test",
      juridica: true,
    },

    operar: {
      load: true,
      check: false,
      comitente: null,
    },
  },
  actions: {
    updateOjito: function ({ commit, state }) {
      commit("updateOjito", !state.ojo);
    },
    setLoadDisponibleView: function ({ commit }, data) {
      commit("setLoadDisponibleView", data);
    },
    checkOperarComitente: async function ({ commit, state, rootGetters }) {
      commit("resetOperar");
      let comitente = state.numero;
      let api = rootGetters["ApiTransferencias/getOperarComitente"](comitente);

      await axios
        .get(api)
        .then((r) => {
          commit("setOperar", { type: "load", value: false });
          if (r.data.success) {
            commit("setOperar", { type: "check", value: true });
            commit("setOperar", { type: "comitente", value: comitente });
          }
        })
        .catch((e) => {
          commit("setOperar", { type: "load", value: false });
          console.log(e);
        });
    },
    setComitenteSel: function ({ commit }) {
      commit("setComitenteSel");
    },
    setCacheComitente: function ({ commit, dispatch }, data) {
      commit("setCacheNumero", data);
    },
    setCacheNumero: function ({ commit }, data) {
      commit("setCacheNumero", data);
    },
    setComitenteBuscado: function ({ commit }, data) {
      commit("setComitenteBuscado", data);
    },
    getComitentes: async function ({ commit, state, rootState, rootGetters }) {
      commit("setComitentesLoad", true);

      //let api = rootState.ApiTransferencias.comitentes.all.endpoint;
      let api = rootGetters["ApiTransferencias/getComitentesAll"];

      await axios
        .get(api)
        .then((r) => {
          commit("setComitentesLoad", false);
          commit("setComitentesData", r.data.data.comitentes);
          //commit('setComitenteByCache');
        })
        .catch((e) => {
          commit("setComitentesLoad", false);
        });
    },

    getCbusHabilitados: async function ({
      commit,
      state,
      rootState,
      rootGetters,
    }) {
      //let api = rootState.ApiTransferencias.cbu.habilitados.endpoint.replace(/{nro_comitente}/ig, state.numero);

      let api = rootGetters["ApiTransferencias/getCbuHabilitados"](
        state.numero
      );

      await axios
        .get(api)
        .then((r) => {
          commit("setCbusHabilitados", r.data);
        })
        .catch((e) => {
          //console.warn(e);
        });
    },
    getTransferencias: async function (
      { commit, state, rootState, rootGetters },
      page
    ) {
      //let api = rootState.ApiTransferencias.transferencias.byComitente.endpoint.replace(/{nro_comitente}/ig, state.numero);
      page = typeof page == "undefined" ? 1 : page;
      let api =
        rootGetters["ApiTransferencias/getTransferencias"](state.numero) +
        "?perPage=10" +
        "&currentPage=" +
        page;

      commit("setLoadTransferencias", true);

      const request = await axios
        .get(api)
        .then((r) => {
          commit("setLoadTransferencias", false);
          commit("setTransferencias", r.data);
        })
        .catch((e) => {
          commit("setTransferencias", {
            code: e.response.status,
            data: {
              transferencia: [],
            },
          });
          commit("setLoadTransferencias", false);
        });
    },
    getCbus: async function ({ commit, state, rootState, rootGetters }, page) {
      //let api = rootState.ApiTransferencias.cbu.byComitente.endpoint.replace(/{nro_comitente}/ig, state.numero);
      page = typeof page == "undefined" ? 1 : page;
      let api =
        rootGetters["ApiTransferencias/getCbuByComitente"](state.numero) +
        "?perPage=10" +
        "&currentPage=" +
        page;

      commit("setLoad", true);
      await axios
        .get(api)
        .then((r) => {
          commit("setLoad", false);
          commit("setCbus", r.data);
        })
        .catch((e) => {
          commit("setLoad", false);
        });
    },
    getCuits: async function ({ commit, state, rootState, rootGetters }, data) {
      //let api = rootState.ApiTransferencias.cbu.cuitsAsociados.endpoint.replace(/{nro_comitente}/ig, state.numero);
      let api = rootGetters["ApiTransferencias/getCuitsAsociados"](
        state.numero
      );

      await axios.get(api).then((r) => {
        commit("setCuits", r.data);
      });
    },
    getDisponible: async function ({ commit, state, rootState, rootGetters }) {
      //let api = rootState.ApiTransferencias.disponible.default.endpoint.replace(/{nro_comitente}/ig, state.numero);
      let api = rootGetters["ApiTransferencias/getDisponible"](state.numero);

      //console.log(state.numero);
      //console.log(api);
      commit("setLoadDisponibleView", true);
      commit("setDisponibleLoad", true);
      commit("clearDisponible");
      const request = await axios
        .get(api)
        .then((r) => {
          let pesos =
            r.data.data.disponible_tesoreria["Pesos"].hoy.total
              .importe_formateado;
          let dolar =
            r.data.data.disponible_tesoreria["Dólar"].hoy.total
              .importe_formateado;
          let mep =
            r.data.data.disponible_tesoreria["MEP Dólar"].hoy.total
              .importe_formateado;
          commit("setDisponibleLoad", false);
          commit("setDisponible", {
            pesos: pesos,
            dolar: dolar,
            mep: mep,
          });
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    getDisponibleFecha: async function (
      { commit, state, rootState, rootGetters },
      fecha
    ) {
      //let api = rootState.ApiTransferencias.disponible.default.endpoint.replace(/{nro_comitente}/ig, state.numero).replace(/{fecha_desde}/ig, state.disponible.date);
      let api =
        rootGetters["ApiTransferencias/getDisponible"](state.numero) +
        "/" +
        fecha;

      commit("setLoadDisponibleView", true);
      commit("setDisponibleLoad", true);
      commit("clearDisponible");
      const request = await axios
        .get(api)
        .then((r) => {
          let pesos =
            r.data.data.disponible_tesoreria["Pesos"].hoy.total
              .importe_formateado;
          let dolar =
            r.data.data.disponible_tesoreria["Dólar"].hoy.total
              .importe_formateado;
          let mep =
            r.data.data.disponible_tesoreria["MEP Dólar"].hoy.total
              .importe_formateado;
          commit("setDisponibleLoad", false);
          commit("setDisponible", {
            pesos: pesos,
            dolar: dolar,
            mep: mep,
          });
        })
        .catch((e) => {
          commit("setDisponibleLoad", false);
        });
    },

    setNumero: function ({ commit, dispatch, state }, data) {
      commit("setNumero", data);
      //dispatch('getDisponibleFecha', state.disponible.date);
    },
    setDisponibleFecha: function (
      { commit, dispatch, state, rootState },
      data
    ) {
      let fecha = moment(data).format("YYYYMMDD");
      commit("setDisponibleFecha", fecha);
      dispatch("getDisponibleFecha", state.disponible.date);
    },

    deleteCbu: async function (
      { commit, dispatch, state, rootState, rootGetters },
      data
    ) {
      //- hacemos consulta delete, ok no cambia nada y devolvemos todos, fail cambia estado
      //let api = rootState.ApiTransferencias.cbu.editEstado.endpoint.replace(/{id_cbu}/ig, data.id);
      let api = rootGetters["ApiTransferencias/getCbuDelete"](
        state.numero,
        data.id
      );

      await axios
        .delete(api)
        .then((r) => {
          dispatch("getCbus");
          dispatch("getCbusHabilitados");
        })
        .catch((e) => {
          if (!!e.response.data.message) {
            if (typeof data.alert != "undefined") {
              data.alert({
                title: "Atención!",
                content: e.response.data.message,
              });
            }
          } else {
            console.warn(e);
          }
        });

      /*
			const request = await axios.put(api, {cbu_tipo_estado_id : 4}).then((r) => {
				dispatch('getCbus');
				dispatch('getCbusHabilitados');
			}).catch((e) => {
				if(!!e.response.data.message){
					if(typeof data.alert != 'undefined'){
						data.alert({
							title : 'Atención!',
							content : e.response.data.message
						});
					}
				}
				else{
					console.warn(e);
				}
			});*/
    },
  },
  mutations: {
    updateOjito: function (state, data) {
      state.ojo = data;
    },
    setLoadDisponibleView: function (state, data) {
      state.load_disponible = data;
    },
    /** permisos para operar */
    setOperar: function (state, data) {
      state.operar[data.type] = data.value;
    },
    resetOperar: function (state) {
      state.operar.load = true;
      state.operar.check = false;
      state.operar.comitente = null;
    },
    /***/
    setComitenteByCache: function (state) {
      /*if(typeof localStorage == 'object'){
				state.numero = localStorage.getItem('webCacheUserComitente');
			}*/
    },
    setComitenteBuscado: function (state, data) {
      state.comitentes.buscados.push(data);
    },
    setComitentesData: function (state, data) {
      state.comitentes.data = data;
      /*
			for(let item of data){
				state.comitentes.data.push({
					numero : item.numComitente,
					denominacion : item.nombre,
					juridica : ((item.EsFisico == '-1')? false : true)
				});
			}
			*/
    },
    setComitentesLoad: function (state, data) {
      state.comitentes.load = data;
    },
    setCbusHabilitados: function (state, data) {
      if (data.code == 200 && data.data.cbu.length > 0) {
        state.cbus_habilitados = data.data.cbu;
      }
    },

    setLoadTransferencias: function (state, data) {
      state.load_transferencias = data;
    },
    setTransferencias: function (state, data) {
      if (data.code == 200 && data.data.transferencia.length > 0) {
        state.transferencias = data.data.transferencia;
        state.transferencias_paginado = data.data.pagination;
      } else {
        state.transferencias = [];
      }
    },

    setLoad: function (state, data) {
      state.load = data;
    },
    setCbus: function (state, data) {
      state.cbus = [];
      if ((data.code == 200 || data.code == 404) && data.data.cbu.length > 0) {
        for (let item of data.data.cbu) {
          if (item.cbu_tipo_estado.id < 5) {
            state.cbus.push(item);
          }
        }

        state.cbus_paginado = data.data.pagination;
      }
    },
    setCacheNumero: function (state, data) {
      if (typeof localStorage == "object") {
        localStorage.setItem("webCacheUserComitente", data);
      }
    },
    setNumero: function (state, data) {
      state.numero = data;
      state.cuits = [];
      state.cbus = [];

      //- seteamos comitente obj para modales
      for (let item of state.comitentes.data) {
        if (item.numero == data) {
          state.comitenteSel = item;
        }
      }
    },
    setCuits: function (state, data) {
      if (data.code == 200 && data.data.cuit_asociado.length > 0) {
        state.cuits = data.data.cuit_asociado;
        //state.cuits.push('30710173652');
      }
    },
    setDisponibleLoad: function (state, data) {
      state.disponible.load = data;
    },
    setDisponibleError: function (state, data) {
      state.disponible.error = data;
    },
    setDisponible: function (state, data) {
      state.disponible.data.pesos = data.pesos;
      state.disponible.data.dolar = data.dolar;
      state.disponible.data.mep = data.mep;
    },
    clearDisponible: function (state) {
      state.disponible.error = null;
      state.disponible.data.pesos = null;
      state.disponible.data.dolar = null;
      state.disponible.data.mep = null;
    },
    setDisponibleFecha: function (state, data) {
      state.disponible.date = data;
    },
  },
};

export default Comitente;
